import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function EDEN1() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>EAH Dataset</BlockTitle>
          {/* <BlockSubtitle>Elemental Digital Environment</BlockSubtitle> */}
        </BlockContent>
        <BlockContent>
          <BlockText>Using a DJI Mavic Pro 2 drone, multiple videos were recorded of the three buildings at EAH Jena. Frames from these videos were extracted and post-processed to remove all visible people. These images were then used in Agisoft Metashape to generate 3D reconstructions of the buildings. The reconstructions were aligned to match the real-world orientation of the structures. Additionally, all intrinsic and extrinsic properties of each image were adjusted to accurately fit the resulting 3D models.</BlockText>
        </BlockContent>
      </Block>



      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
            <ul>
                <li>Photogrammetric 3D reconstructions of the three buildings of the EAH Jena.</li>
                <li>Each building comes with a set of images of size 3840 x 2160 px.</li>
                <li>Each image has a json with corresponding intrinsic and extrinsic properties.</li>
                <li>The capture time for each building is included.</li>
                <li>Published in the paper <b>Enhanced Illumination Adjustment in 3D Outdoor Reconstructions via Shadow Removal through Color Transfer</b>.</li>
            </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/card_eden-I_2.webp'}/>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="400px 400px 400px">
        <BlockContent textAlign="center">
        <BlockSubtitle>House 123</BlockSubtitle>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/house_123.webp'}/>
        </BlockContent>
        <BlockContent textAlign="center">
        <BlockSubtitle>House 4</BlockSubtitle>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/house_4.webp'}/>
        </BlockContent>
        <BlockContent textAlign="center">
        <BlockSubtitle>House 5</BlockSubtitle>
              <BlockImage shadow={false} src={process.env.PUBLIC_URL + '/images/projects/house_5.webp'}/>
        </BlockContent>
      </Block>

      {/* <Block colorTheme="light" gridTemplateColumns="600px">
      <BlockContent textAlign="center" color="grey" fontStyle="italic">
        <BlockButton disabled onClick={() => window.open('https://potechius.com/Downloads/EDEN.zip')}>Download</BlockButton>
        </BlockContent>
      </Block> */}
     <Block colorTheme="dark" gridTemplateColumns="1200px">
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/EahDataset')}>Download</BlockButton>
        </BlockContent>
      </Block>



      <Footer/>
    </div>
  );
}

export default EDEN1;